import { SiteType } from "@ots-frontend/ots-data";
import { useTranslation } from "react-i18next";
import { Badge } from "../Badge/Badge";
import { getSiteColorRefByType } from "../../../util/site-ui-util";

export type SiteTypeBadgeProps = {
  type: SiteType
}

export const SiteTypeBadge = (props: SiteTypeBadgeProps) => {
  const { type } = props;

  const { t } = useTranslation(["common"]);

  return (
    <Badge color={getSiteColorRefByType(type)} variant="filled">
      {t(type.displayValue.id, type.displayValue.defaultMessage)}
    </Badge>
  );
};
